module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"voteFor":"Vote for","good":"Good","great":"Great","perfect":"Perfect","alertMessage":"Vote was submitted! Thank you."},"es":{"voteFor":"Vota por","good":"Bien","great":"Genial","perfect":"Perfecto","alertMessage":"El voto ha sido enviado! Gracias."}}')
  delete Component.options._Ctor
}
